import { memo, useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { ICanPayItem, IOnScrollData } from '@/sub-luca-plugin/types';
import { IScrollViewContext, ScrollView } from '@/sub-luca-plugin/compatible-components';
import './index.scss';

const EquityCards = ({
    canPayList,
    productId,
    categoryTitles,
    onSwitchEquity,
    title,
}: {
    productId?: number;
    categoryTitles: string[];
    canPayList?: ICanPayItem[];
    title?: string;
    onSwitchEquity: (data: ICanPayItem) => void;
}) => {
    const scrollViewContext = useRef<IScrollViewContext>();
    const [isPayScroll, setIsPayScroll] = useState(false);

    const handleSwitchEquity = (data: ICanPayItem, index: number) => {
        const id = `#equity-card-details__item-${index}`;
        scrollViewContext.current?.scrollIntoView(id);
        onSwitchEquity(data);
    };

    const handleScroll = useCallback(({ scrollLeft }: IOnScrollData) => {
        setIsPayScroll(scrollLeft > 8 ? true : false);
    }, []);

    useEffect(() => {
        if (canPayList?.length) {
            handleSwitchEquity(canPayList[0], 0);
        }
    }, [canPayList]);

    if (!canPayList?.length) return null;

    return (
        <div className="equity-cards">
            <div className="equity-cards__list">
                {canPayList.map((item, index) => (
                    <div
                        key={item.id}
                        onClick={() => handleSwitchEquity(item, index)}
                        className={classNames('equity-cards__item-money', {
                            active: productId === item.productId,
                        })}
                    >
                        <div>{item.equityTitle.substring(0, 6)}</div>
                        <div>
                            ¥<span style={{ fontSize: String(item.amount).length > 5 ? 28 : 32 }}>{item.amount}</span>
                        </div>
                    </div>
                ))}
            </div>
            {title && <div className="equity-card-details__list-title">{title}</div>}
            <div className="equity-card-details__list-container">
                <div className={classNames('equity-card-details__categories', isPayScroll && 'equity-card-details__categories--scroll')}>
                    {categoryTitles.map(item => (
                        <div key={item} className="equity-card-details__categories-item">
                            {item}
                        </div>
                    ))}
                </div>
                <ScrollView className="equity-card-details__scroll-container" ref={scrollViewContext} scrollX onScroll={handleScroll}>
                    <div className="equity-card-details__list">
                        {canPayList.map((item, index) => (
                            <div
                                key={item.id}
                                id={`equity-card-details__item-${index}`}
                                className={classNames('equity-card-details__item', {
                                    active: item.productId === productId,
                                })}
                            >
                                <div>{item.equityTitle.substring(0, 6)}</div>
                                <div>{item.lucaAskNumStr}</div>
                                <div>{item.teacherAskNumStr}</div>
                                {item.aiCorrectNumStr && <div>{item.aiCorrectNumStr}</div>}
                                {item.manualCorrectNumStr && <div>{item.manualCorrectNumStr}</div>}
                                <div>{item.validityTimeStr}</div>
                            </div>
                        ))}
                    </div>
                </ScrollView>
            </div>
        </div>
    );
};
export default memo(EquityCards);
